import React from 'react'
import type { EventGQL } from '../../../Api'
import { getTeamIc } from '../../../Utils'
import { FinalScoreCon } from './styles'

type FinalProps = {
  event: EventGQL
}

export const Final: React.FC<React.PropsWithChildren<FinalProps>> = ({ event }) => {
  return (
    <FinalScoreCon>
      {event && (
        <>
          {event.awayTeam && (
            <img
              src={getTeamIc(event.awayTeam.fullName)}
              alt={`${event.awayTeam.fullName}`}
            />
          )}
          <p>
            {event.visitorScore} - {event.homeScore}
          </p>
          {event.homeTeam && (
            <img
              src={getTeamIc(event.homeTeam.fullName)}
              alt={`${event.homeTeam.fullName}`}
            />
          )}
        </>
      )}
    </FinalScoreCon>
  )
}
